import { render, staticRenderFns } from "./AdoptionReview.vue?vue&type=template&id=3546d22e&scoped=true&"
import script from "./AdoptionReview.vue?vue&type=script&lang=js&"
export * from "./AdoptionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546d22e",
  null
  
)

export default component.exports